<script>
	import { pageNumber, model } from "../../stores";

	import Checkbox from "../../components/Checkbox.svelte";
	import Notice from "./components/Notice.svelte";

	export let pageIndex = null;

	let stage = "review";

	$pageNumber = pageIndex;
</script>

<section>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">NUIX Shareholder Class Action</h1>
			<h2 class="text-center">NOTICE OF OPTING OUT BY GROUP MEMBER</h2>
			<h2 class="text-center">
				Willian Lay & Daniel Joseph Batchelor v Nuix Limited & Ors
				<br /><span style="font-weight: 300">(S ECI 2021 04360).</span>
			</h2>
		</div>
	</div>

	<div class="row justify-content-md-center register-btn">
		<div class="col-md-8 col-sm-12">
			<hr />
			<p>
				<b
					>Do you agree to provide us with personal information which will be kept confidential under the <a
						href="https://www.shine.com.au/privacy-policy"
						title="Privacy Policy"
						target="_blank">Shine Lawyers Privacy Policy</a
					>?</b
				>
			</p>
			<Checkbox
				disabled
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the privacy policy</a>"
				id="privacy"
			></Checkbox>
		</div>
	</div>

	<Notice disabled {stage} />
</section>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	a {
		text-decoration: none;
	}

	.register-btn {
		margin-bottom: 20px;
	}
</style>
